import { Status } from "ui";

import {
  RETURN_CHANGING_STATUSES,
  RETURN_STATUSES_LIST,
  ReturnStatus
} from "../../../constants";

interface useReturnStatusesProps {
  openedItemStatusesIndex: number | null;
  setActionConfirmingIndex: React.Dispatch<React.SetStateAction<number | null>>;
  openApproveModal: () => void;
  openRejectModal: () => void;
}

const getOrderStatusIndex = (st: string, statusesList: Status[]) =>
  statusesList.findIndex((status) => status.value === st);

export const useReturnStatuses = ({
  openedItemStatusesIndex,
  setActionConfirmingIndex,
  openApproveModal,
  openRejectModal
}: useReturnStatusesProps) => {
  const statusesList: Status[] = RETURN_STATUSES_LIST.map((orStatus) => ({
    ...orStatus
  }));

  const changingStatusesList: Status[] = RETURN_CHANGING_STATUSES.map(
    (orStatus) => ({
      ...orStatus,
      onClick: () => {
        if (openedItemStatusesIndex === null) return;

        if (orStatus.value === ReturnStatus.ReturnApproved) {
          setActionConfirmingIndex(openedItemStatusesIndex);
          openApproveModal();
        }

        if (orStatus.value === ReturnStatus.ReturnRejected) {
          setActionConfirmingIndex(openedItemStatusesIndex);
          openRejectModal();
        }
      }
    })
  );

  return {
    statusesList,
    changingStatusesList,
    getOrderStatusIndex
  };
};
